import React, { useContext } from "react";

const authStatusContext = React.createContext({ isAuthorized: false });

export const { Provider: AuthStatusContextProvider } = authStatusContext;

const useIsAuthorized = () => useContext(authStatusContext)?.isAuthorized ?? false;

export default useIsAuthorized;
